<template>
    <v-card height="450">
        <h3 class="headline py-3 text-xs-center">{{ organizationExpiredMsg }}</h3>
        <v-img
                :aspect-ratio="3.44"
                :src="require('../../public/img/expire_org.jpg')"
                contain
                height="300"
        >
        </v-img>
        <div class="text-xs-center subheading pa-3">
            To Continue using Magnify Insights Tool please contact our customer service team.
            Don't Worry about your data.It is safely store.
        </div>
    </v-card>
</template>

<script>
	export default {
		name: "AppOrgExpireAlert",
		props: {
			organizationExpiredMsg: {
				required: true
			}
		}
	}
</script>

<style scoped>

</style>
